import { render, staticRenderFns } from "./ContractorsMultiselectWithBookmarks.vue?vue&type=template&id=f8db80b2"
import script from "./ContractorsMultiselectWithBookmarks.vue?vue&type=script&lang=ts"
export * from "./ContractorsMultiselectWithBookmarks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8db80b2')) {
      api.createRecord('f8db80b2', component.options)
    } else {
      api.reload('f8db80b2', component.options)
    }
    module.hot.accept("./ContractorsMultiselectWithBookmarks.vue?vue&type=template&id=f8db80b2", function () {
      api.rerender('f8db80b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ContractorsMultiselectWithBookmarks.vue"
export default component.exports